<template>
  <div class="navContent min-w-limit">
    <div class="navBar max-w-limit">
      <div class="logoBlock">
        <span class="logoTitle">CPT THANH VAN JOINT STOCK COMPANY</span>
      </div>
      <div class="navGroup">
        <router-link v-for="route in routes" :key="route.path" :to="route.path" class="navItem" :class="{ 'nav-active': $route.path === route.path }">
           {{ route.title }}
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { routes } from '../router'; 

export default {
  data() {
    return {
      routes,
    };
  }
};
</script>
<style scoped>
.navContent {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 80px;
  position: sticky; 
  top: 0;
  z-index: 1000;
}

.navBar {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0px 160px;
  background-color: #ffffff;
  box-shadow:0px 3px 3px #41404010;
}

.logoBlock {
  display: flex;
  align-items: center;
}

.logoImg {
  width: 60px;
  height: 60px;
  margin-left: 50px;
}

.logoTitle {
  font-weight: bold;
  color: black;
  font-size: 16px;
  font-family: Roboto Flex-SemiBold;
  color: #333333;
}

.navGroup {
  display: flex;
  align-items: center;
  justify-content: center;
}

.navItem{
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 15px;
  margin-left: 15px;
  font-size: 16px;
  font-family: SF Pro-Semibold;
  font-weight: 400;
  color: #333333;
  transition: none;
}

.nav-active {
  border-radius: 30px;
  font-weight: 700;
  color: #377CFD;
}

</style>
